export const SocialAccountFields = [
  { name: 'Instagram' },
  { name: 'TikTok' },
  { name: 'YouTube' },
  { name: 'Twitter' },
  { name: 'Pinterest' },
  { name: 'Facebook' },
  { name: 'Blog' },
];
